import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import { inject, observer } from 'mobx-react';
import LoginView from './LoginView';

class WithLoginWrapperView extends Component {

  	componentDidMount() {    
		const { store } = this.props;
		let token = store.sessionToken;		
		if (!token) {
			store.hasSessionToken.set(false);
			return;
		}
		const currentDate = new Date();
		let expirationDate = null;    
		try {
		  	expirationDate = new Date(store.claims.expires);
		} catch (e) {
			store.hasSessionToken.set(false);      
			return;      
		}
		//console.log(expirationDate, 'XXXXX', currentDate);
		if (expirationDate <= currentDate) {
			store.hasSessionToken.set(false);
			return;
		}
		store.hasSessionToken.set(true);
  	}

  render() {
    const { store } = this.props;
    if (!store.hasSessionToken.get()) {   
      return (
        <LoginView />
      );
    }
    return (
      <span>
        {this.props.children}
      </span>
    );
  }

}

export default withRouter(inject('store')(observer(WithLoginWrapperView)));



// WEBPACK FOOTER //
// ./src/views/WithLoginWrapperView.js